import { TTransferStatus } from '@remote/type/upload'

export const Events = {
  UploadTaskStart: 'UploadTask.start',
  UploadTaskChange: 'UploadTask.change',
  UploadTaskError: 'UploadTask.error',
  UploadTaskPending: 'UploadTask.pending',
  UploadTaskTransitServerProgress: 'UploadTask.transitServerProgress',
  UploadTaskTransitServerCompleted: 'UploadTask.transitServerCompleted',
  UploadTaskDeviceReceiveProgress: 'UploadTask.deviceReceiveProgress',
  UploadTaskDeviceReceiveCompleted: 'UploadTask.deviceReceiveCompleted',
  UploadTaskdelete: 'UploadTask.delete',
  UploadTaskRun: 'UploadTask.run',
  UploadTaskBatchUpdate: 'UploadTask.batchUpdate',
  UploadTaskPause: 'UploadTask.Pause',
  UploadTaskPauseWaitDeviceReceive: 'UploadTaskPause.WaitDeviceReceive',
}

export const Status = {
  UploadPending: 'Upload.pending',
  UploadTransmitting: 'Upload.transmitting',
  UploadSuspend: 'Upload.suspend',
  UploadFailure: 'Upload.failure',
  UploadDeleted: 'Upload.deleted',
  UploadTransitServerCompleted: 'Upload.transitServerCompleted',
  UploadCompleted: 'Upload.completed',
} as {[key: string]: TTransferStatus}

export const chunkSize = 1024 * 1024 * 1 // 1M

export default Events